import { useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import { AutocompleteInput, ReferenceInput } from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import SubmitFilters from "../components/filters/SubmitFilters";
import { usersConfig } from "../users";
import RangesInput from "./inputs/RangesInput";

const Filters = (props) => {
	const theme = useTheme();
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	return (
		<SubmitFilters {...props}>
			<RangesInput
				source="range"
				alwaysOn
				fullWidth
				style={{ marginTop: theme.spacing(4) }}
			/>
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				alwaysOn
				fullWidth
				{...bookmakersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<ReferenceInput
				source="user_id"
				reference="users"
				alwaysOn={!sm}
				fullWidth
				{...usersConfig.reference}
			>
				<AutocompleteInput optionText="name" resettable />
			</ReferenceInput>
		</SubmitFilters>
	);
};
export default Filters;
